export enum Subjects {
  // Organisation
  ORGANISATION = 'Organisation',
  ORG_USER = 'OrgUser',
  // Project
  PROJECT = 'Project',
  PROJECT_USER = 'ProjectUser',
  PROJECT_CASHFLOW = 'ProjectCashflow',
  PROJECT_BUDGET_SUMMARY_CARD = 'ProjectBudgetSummaryCard',
  // Site
  SITE = 'Site',
  SITE_USER = 'SiteUser',
  SITE_CASHFLOW = 'SiteCashflow',
  SITE_PROJECT_BUDGET_SUMMARY_TILES = 'SiteProjectBudgetSummaryTiles',
  // Vendor
  ORG_VENDOR = 'OrgVendor',
  BOQ_VENDOR = 'BOQVendor',
  // Vendor Item
  ORG_VENDOR_ITEM = 'OrgVendorItem',
  BOQ_VENDOR_ITEM = 'BOQVendorItem',
  // BOQ
  BOQ = 'BOQ', // includes claims view
  SELLING_BOQ = 'SellingBOQ', // view selling boq, budget summary, internal variations
  BOQ_TEMPLATE = 'BOQTemplate',
  BOQ_ITEM = 'BOQItem', // relates managing section/subsections, groups, claims
  BOQ_VARIATION = 'BOQVariation',
  CLIENT_VARIATION = 'ClientVariation',
  CLIENT_VARIATION_PAYMENT = 'ClientVariationPayment',
  // Provisional budgets. M1 grants read, create and the decision on a create request, with no
  // act-kind condition. The kind joins the check as a condition when the amount increase brings
  // a second set of approvers (M3), so no new Action is needed.
  PROVISIONAL_BUDGET = 'ProvisionalBudget',
  // Order/Claim & Cart
  CART = 'Cart', // includes cart items
  ORDER = 'Order',
  ORDER_VARIATION = 'OrderVariation',
  ORDER_DOCUMENTATION = 'OrderDocumentation',
  ORDER_DELIVERY = 'OrderDelivery',
  BULK_ORDER = 'BulkOrder',
  // Payments, PRs & APs
  PAYMENT_REQUEST = 'PaymentRequest', // Includes totals
  // A payment request carrying the bulk-order marker, which declines through its own arm (DL-205).
  BULK_PAYMENT_REQUEST = 'BulkPaymentRequest',
  PR_DOCUMENTATION = 'PRDocumentation',
  ACCOUNTS_PAYABLE = 'AccountsPayable', // Includes all tabs in AP
  PAYMENT = 'Payment',
  // Adhoc/advance (ADV) payment creation. Split from PAYMENT so ORG_ADMIN can be
  // depowered from creating ADV payments (PE-214/PE-212) without losing the retained
  // Log Payment options, which remain gated on PAYMENT.
  ADHOC_PAYMENT = 'AdhocPayment',
  // The organisation-level payments surface (the Accounts > Payments tab, its routes and the
  // proof-ingestion settings read). Split from PAYMENT because LIST:PAYMENT also admits project
  // and site roles, while the API's view rule admits only the org finance tier (DL-119, DL-152).
  PAYMENTS_SURFACE = 'PaymentsSurface',
  AP_STATEMENT = 'APStatement',
  // Compliance
  COMPLIANCE = 'Compliance',
  COMPLIANCE_TEMPLATE = 'ComplianceTemplate',
  COMPLIANCE_DOCUMENT = 'ComplianceDocument',

  RETURN = 'Return',
  CREDIT = 'Credit',
  REFUND = 'Refund',
  ORG_DASHBOARD = 'OrgDashboard',
  CLIENT_DASHBOARD = 'ClientDashboard',
  // Funder drawdowns and the claim sheet generated from a draw. Separate subjects because
  // their audiences differ: professionals see draws but never generate a claim (PLE-1236 A4).
  BANK_DRAW = 'BankDraw',
  CLAIM_SHEET = 'ClaimSheet',
  // The site's commencement and completion dates, which generate the draw schedule the rows
  // hang off. Separate from BANK_DRAW because the audiences differ in the other direction:
  // org finance fills in the draw amounts but does not decide the site's dates (PLE-1236 A6).
  DRAW_SCHEDULE = 'DrawSchedule',
  // VendorControl
  VC_VENDOR = 'VCVendor',
  VC_ITEM = 'VCItem',
  VC_INGESTION = 'VCIngestion',
  VC_PRICING = 'VCPricing',
  VC_COMPLIANCE = 'VCCompliance',
  VC_STAGING = 'VCStaging',
  VC_AUDIT_LOG = 'VCAuditLog',
  VC_SETTINGS = 'VCSettings',
  ALL = 'all',
}
